export default __webpack_public_path__ + "static/media/ABChanelCorpo-Light.e3333e88.woff2";